import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FilterType } from '../../components/myCrates/folder-management/types';

export const filtersInitialState: FilterType = {
  name: undefined,
  status: undefined,
  minTrackCount: undefined,
  maxTrackCount: undefined,
  minViewCount: undefined,
  maxViewCount: undefined,
  minSaveCount: undefined,
  maxSaveCount: undefined,
  minCrateCount: undefined,
  maxCrateCount: undefined,
  minSubfolderCount: undefined,
  maxSubfolderCount: undefined,
  CreatedStartDate: undefined,
  CreatedEndDate: undefined,
  lastModifiedStartDate: undefined,
  lastModifiedEndDate: undefined,
  isCrate: true,
};
export type FolderSortField =
  | 'name'
  | 'createdAt'
  | 'modifiedAt'
  | 'crateCount'
  | 'trackCount'
  | 'viewCount'
  | 'saveCount'
  | 'status'
  | 'none';

export type SortDirection = 'asc' | 'desc';

export type SortState = {
  field: FolderSortField;
  direction?: SortDirection;
};
type MyCratesFolderFilterState = {
  filters: FilterType;
  filtersApplied: boolean;
  filterIsVisible: boolean;
  customFolderCreatorIsVisible: boolean;
  operationType: 'foldersOnly' | 'folders-Crates' | 'CratesOnly';
  sortFields: SortState;
};

const initialState: MyCratesFolderFilterState = {
  filters: filtersInitialState,
  filtersApplied: false,
  filterIsVisible: false,
  customFolderCreatorIsVisible: false,
  operationType: 'folders-Crates',
  sortFields: {
    field: 'none',
    direction: 'asc',
  },
};
const myCratesFolderFilterSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    updateFilters: (state, action: PayloadAction<Partial<FilterType>>) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };

      state.filtersApplied = false;
    },

    setFilter: <K extends keyof FilterType>(
      state: MyCratesFolderFilterState,
      action: PayloadAction<{
        key: K;
        value: FilterType[K];
      }>,
    ) => {
      const value =
        typeof action.payload.value === 'object' &&
        action.payload.value !== null
          ? undefined
          : action.payload.value;

      state.filters[action.payload.key] = value as FilterType[K];

      state.filtersApplied = false;
    },

    setInitialFilters: (state, action: PayloadAction<FilterType>) => {
      state.filters = action.payload;
    },
    applyFilters: (state) => {
      state.filtersApplied = true;
    },

    resetFilters: (state) => {
      const isCrate = state.filters.isCrate;
      state.filters = {
        ...filtersInitialState,
        isCrate,
      };

      state.filtersApplied = false;
    },

    setFilterIsVisible: (state, action: PayloadAction<boolean>) => {
      state.filterIsVisible = action.payload;
    },

    setCustomFolderCreatorIsVisible: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.customFolderCreatorIsVisible = action.payload;
    },

    setOperationType: (
      state,
      action: PayloadAction<'foldersOnly' | 'folders-Crates' | 'CratesOnly'>,
    ) => {
      state.operationType = action.payload;
    },
    setSortField: (state, action: PayloadAction<FolderSortField>) => {
      state.sortFields.field = action.payload;
    },

    setSortDirection: (state, action: PayloadAction<SortDirection>) => {
      state.sortFields.direction = action.payload;
    },
  },
});

export const {
  updateFilters,
  setFilter,
  applyFilters,
  resetFilters,
  setFilterIsVisible,
  setSortDirection,
  setSortField,
  setOperationType,
  setCustomFolderCreatorIsVisible,
  setInitialFilters,
} = myCratesFolderFilterSlice.actions;

export default myCratesFolderFilterSlice.reducer;
